import { createContext, useContext } from "react";
import useWebSocketNotification from "../hooks/useWebSocketNotification";

const WebSocketContext = createContext();

export const WebSocketProvider = ({ djId, children }) => {
  // const { notifications, unreadCount, markAllAsRead } =
  //   useWebSocketNotification(djId, true);

  return (
    <WebSocketContext.Provider
    // value={{ notifications, unreadCount, markAllAsRead }}
    >
      {children}
    </WebSocketContext.Provider>
  );
};

export const useWebSocketContext = () => useContext(WebSocketContext);
